import { createReducer, on } from "@ngrx/store";
import { AutomationActions } from "../actions/automation.actions";
import { initialAutomationState } from "../states/automation.state";

export const automationReducer = createReducer(
  initialAutomationState,

  /** APPLICATIONS **/
  on(AutomationActions.loadApplications, (state) => ({
    ...state,
    loading: true,
  })),
  on(
    AutomationActions.loadApplicationsSuccess,
    (state, { automationProjectId, applications }) => ({
      ...state,
      applications: {
        ...state.applications,
        [automationProjectId]: applications,
      },
      loading: false,
      error: null,
    })
  ),
  on(AutomationActions.addApplication, (state) => ({
    ...state,
    loading: true,
  })),
  on(
    AutomationActions.addApplicationSuccess,
    (state, { automationProjectId, application }) => ({
      ...state,
      applications: {
        ...state.applications,
        [automationProjectId]: [
          ...(state.applications[automationProjectId] || []),
          application,
        ],
      },
      loading: false,
      error: null,
    })
  ),
  on(AutomationActions.deleteApplication, (state) => ({
    ...state,
    loading: true,
  })),
  on(
    AutomationActions.deleteApplicationSuccess,
    (state, { automationProjectId, id }) => {
      return {
        ...state,
        applications: {
          ...state.applications,
          [automationProjectId]:
            state.applications[automationProjectId]?.filter(
              (app) => app.id !== id
            ) || [],
        },
        loading: false,
        error: null,
      };
    }
  ),
  on(AutomationActions.deleteApplications, (state) => ({
    ...state,
    loading: true,
  })),
  on(
    AutomationActions.deleteApplicationsSuccess,
    (state, { automationProjectId, idList }) => {
      return {
        ...state,
        applications: {
          ...state.applications,
          [automationProjectId]:
            state.applications[automationProjectId]?.filter(
              (app) => !idList.includes(app?.id)
            ) || [],
        },
        loading: false,
        error: null,
      };
    }
  ),
  on(AutomationActions.updateApplication, (state) => ({
    ...state,
    loading: true,
  })),
  on(
    AutomationActions.updateApplicationSuccess,
    (state, { automationProjectId, application }) => ({
      ...state,
      applications: {
        ...state.applications,
        [automationProjectId]: [
          ...(state.applications[automationProjectId] || []).map((app) =>
            app.id === application.id ? application : app
          ),
        ],
      },
      loading: false,
      error: null,
    })
  ),

  /** PAGES **/
  on(AutomationActions.loadPages, (state) => ({ ...state, loading: true })),
  on(AutomationActions.loadPagesSuccess, (state, { applicationId, pages }) => ({
    ...state,
    pages: { ...state.pages, [applicationId]: pages },
    loading: false,
    error: null,
  })),
  on(AutomationActions.addPage, (state) => ({ ...state, loading: true })),
  on(AutomationActions.addPageSuccess, (state, { applicationId, page }) => ({
    ...state,
    pages: {
      ...state.pages,
      [applicationId]: [...(state.pages[applicationId] || []), page],
    },
    loading: false,
    error: null,
  })),
  on(AutomationActions.deletePage, (state) => ({ ...state, loading: true })),
  on(AutomationActions.deletePageSuccess, (state, { applicationId, id }) => {
    return {
      ...state,
      pages: {
        ...state.pages,
        [applicationId]:
          state.pages[applicationId]?.filter((page) => page.id !== id) || [],
      },
      loading: false,
      error: null,
    };
  }),
  on(AutomationActions.deletePages, (state) => ({ ...state, loading: true })),
  on(
    AutomationActions.deletePagesSuccess,
    (state, { applicationId, idList }) => {
      return {
        ...state,
        pages: {
          ...state.pages,
          [applicationId]:
            state.pages[applicationId]?.filter(
              (page) => !idList.includes(page?.id)
            ) || [],
        },
        loading: false,
        error: null,
      };
    }
  ),
  on(AutomationActions.updatePage, (state) => ({ ...state, loading: true })),
  on(AutomationActions.updatePageSuccess, (state, { applicationId, page }) => ({
    ...state,
    pages: {
      ...state.pages,
      [applicationId]: [
        ...(state.pages[applicationId] || []).map((pg) =>
          pg.id === page.id ? page : pg
        ),
      ],
    },
    loading: false,
    error: null,
  })),

  /** UI PBJECTS **/
  on(AutomationActions.loadUiObjects, (state) => ({ ...state, loading: true })),
  on(
    AutomationActions.loadUiObjectsSuccess,
    (state, { pageId, uiObjects }) => ({
      ...state,
      uiObjects: { ...state.uiObjects, [pageId]: uiObjects },
      loading: false,
      error: null,
    })
  ),
  on(AutomationActions.addUiObject, (state) => ({ ...state, loading: true })),
  on(AutomationActions.addUiObjectSuccess, (state, { pageId, uiObject }) => ({
    ...state,
    uiObjects: {
      ...state.uiObjects,
      [pageId]: [...(state.uiObjects[pageId] || []), { ...uiObject }],
    },
    loading: false,
    error: null,
  })),
  on(AutomationActions.deleteUiObject, (state) => ({
    ...state,
    loading: true,
  })),
  on(AutomationActions.deleteUiObjectSuccess, (state, { pageId, id }) => {
    return {
      ...state,
      uiObjects: {
        ...state.uiObjects,
        [pageId]:
          state.uiObjects[pageId]?.filter((uiObject) => uiObject.id !== id) ||
          [],
      },
      loading: false,
      error: null,
    };
  }),

  on(AutomationActions.deleteUiObjects, (state) => ({
    ...state,
    loading: true,
  })),
  on(AutomationActions.deleteUiObjectsSuccess, (state, { pageId, idList }) => {
    return {
      ...state,
      uiObjects: {
        ...state.uiObjects,
        [pageId]:
          state.uiObjects[pageId]?.filter(
            (uiObject) => !idList.includes(uiObject?.id)
          ) || [],
      },
      loading: false,
      error: null,
    };
  }),
  on(AutomationActions.updateUiObject, (state) => ({
    ...state,
    loading: true,
  })),
  on(
    AutomationActions.updateUiObjectSuccess,
    (state, { applicationId, pageId, uiObject }) => ({
      ...state,
      uiObjects: {
        ...state.uiObjects,
        [pageId]: (state.uiObjects[pageId] || []).map(
          (obj) => (obj.id === uiObject.id ? uiObject : obj) // Replace if ID matches
        ),
      },
      loading: false,
      error: null,
    })
  ),

  // Script Groups
  on(AutomationActions.loadScriptGroup, (state) => ({
    ...state,
    loading: true,
  })),
  on(
    AutomationActions.loadScriptGroupSuccess,
    (state, { scriptGroup, testScript }) => ({
      ...state,
      scriptGroup,
      testScript,
      loading: false,
      error: null,
    })
  ),
  on(AutomationActions.addScriptGroupSuccess, (state, { scriptGroup }) => ({
    ...state,
    scriptGroup: [...state.scriptGroup, scriptGroup],
    loading: false,
  })),
  on(AutomationActions.deleteScriptGroup, (state) => ({
    ...state,
    loading: true,
  })),
  on(AutomationActions.deleteScriptGroupSuccess, (state, { id }) => {
    return {
      ...state,
      scriptGroup: state.scriptGroup.filter((item) => item.id !== id),
      loading: false,
    };
  }),
  on(AutomationActions.deleteScriptGroups, (state) => ({
    ...state,
    loading: true,
  })),
  on(AutomationActions.deleteScriptGroupsSuccess, (state, { idList }) => {
    return {
      ...state,
      scriptGroup: state.scriptGroup.filter(
        (item) => !idList.includes(item.id)
      ),
      loading: false,
    };
  }),
  on(AutomationActions.updateScriptGroup, (state) => ({
    ...state,
    loading: true,
  })),
  on(AutomationActions.updateScriptGroupSuccess, (state, { scriptGroup }) => ({
    ...state,
    ...state,
    scriptGroup: state.scriptGroup.map((item) =>
      item.id === scriptGroup?.data?.id ? scriptGroup?.data : item
    ),
    loading: false,
    error: null,
  })),

  // Test Script
  on(AutomationActions.loadTestScript, (state) => ({
    ...state,
    loading: false,
  })),
  on(AutomationActions.loadTestScriptSuccess, (state, { testScript }) => ({
    ...state,
    testScript,
    loading: false,
    error: null,
  })),
  on(AutomationActions.addTestScriptSuccess, (state, { testScript }) => ({
    ...state,
    testScript: [...state.testScript, testScript],
    loading: false,
  })),
  on(AutomationActions.deleteTestScript, (state) => ({
    ...state,
    loading: true,
  })),
  on(AutomationActions.deleteTestScriptSuccess, (state, { id }) => {
    return {
      ...state,
      testScript: state.testScript.filter((item) => item.id !== id),
      loading: false,
    };
  }),
  on(AutomationActions.deleteTestScripts, (state) => ({
    ...state,
    loading: true,
  })),
  on(AutomationActions.deleteTestScriptsSuccess, (state, { idList }) => {
    return {
      ...state,
      testScript: state.testScript.filter((item) => !idList.includes(item.id)),
      loading: false,
    };
  }),
  on(AutomationActions.updateTestScript, (state) => ({
    ...state,
    loading: true,
  })),
  on(AutomationActions.updateTestScriptSuccess, (state, { testScript }) => ({
    ...state,
    testScript: state.testScript.map((item) =>
      item.id === testScript?.data?.id ? testScript?.data : item
    ),
    loading: false,
    error: null,
  })),

  // Reusable Script Groups
  on(AutomationActions.loadReusableComponent, (state) => ({
    ...state,
    loading: true,
  })),
  on(
    AutomationActions.loadReusableComponentSuccess,
    (state, { reusableComponent, reusableScript }) => ({
      ...state,
      reusableComponent,
      reusableScript,
      loading: false,
      error: null,
    })
  ),
  on(
    AutomationActions.addReusableComponentSuccess,
    (state, { reusableComponent }) => ({
      ...state,
      reusableComponent: [...state.reusableComponent, reusableComponent],
      loading: false,
    })
  ),
  on(AutomationActions.deleteReusableComponent, (state) => ({
    ...state,
    loading: true,
  })),
  on(AutomationActions.deleteReusableComponentSuccess, (state, { id }) => {
    return {
      ...state,
      reusableComponent: state.reusableComponent.filter(
        (item) => item.id !== id
      ),
      loading: false,
    };
  }),
  on(AutomationActions.deleteReusableComponents, (state) => ({
    ...state,
    loading: true,
  })),
  on(AutomationActions.deleteReusableComponentsSuccess, (state, { idList }) => {
    return {
      ...state,
      reusableComponent: state.reusableComponent.filter(
        (item) => !idList.includes(item.id)
      ),
      loading: false,
    };
  }),
  on(AutomationActions.updateReusableComponent, (state) => ({
    ...state,
    loading: true,
  })),
  on(
    AutomationActions.updateReusableComponentSuccess,
    (state, { reusableComponent }) => ({
      ...state,
      reusableComponent: state.reusableComponent.map((item) =>
        item.id === reusableComponent?.data?.id ? reusableComponent?.data : item
      ),
      loading: false,
      error: null,
    })
  ),

  // Reusable Script
  on(AutomationActions.loadReusableScript, (state) => ({
    ...state,
    loading: true,
  })),
  on(
    AutomationActions.loadReusableScriptSuccess,
    (state, { reusableScript }) => ({
      ...state,
      reusableScript,
      loading: false,
      error: null,
    })
  ),
  on(AutomationActions.addReusableScript, (state) => ({
    ...state,
    loading: false,
  })),
  on(
    AutomationActions.addReusableScriptSuccess,
    (state, { reusableScript }) => ({
      ...state,
      reusableScript: [...state.reusableScript, reusableScript],
      loading: false,
    })
  ),
  on(AutomationActions.deleteReusableScript, (state) => ({
    ...state,
    loading: true,
  })),
  on(AutomationActions.deleteReusableScriptSuccess, (state, { id }) => {
    return {
      ...state,
      reusableScript: state.reusableScript.filter((item) => item.id !== id),
      loading: false,
    };
  }),

  on(AutomationActions.deleteReusableScripts, (state) => ({
    ...state,
    loading: true,
  })),
  on(AutomationActions.deleteReusableScriptsSuccess, (state, { idList }) => {
    return {
      ...state,
      reusableScript: state.reusableScript.filter(
        (item) => !idList.includes(item.id)
      ),
      loading: false,
    };
  }),
  on(AutomationActions.updateReusableScript, (state) => ({
    ...state,
    loading: true,
  })),
  on(
    AutomationActions.updateReusableScriptSuccess,
    (state, { reusableScript }) => ({
      ...state,
      reusableScript: state.reusableScript.map((item) =>
        item.id === reusableScript?.data?.id ? reusableScript?.data : item
      ),
      loading: false,
      error: null,
    })
  ),

  /** COMMAND DEFINITIONS */

  on(AutomationActions.loadCommandDefinitions, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(
    AutomationActions.loadCommandDefinitionsSuccess,
    (state, { commandDefinitions }) => ({
      ...state,
      commandDefinitions,
      loading: false,
      error: null,
    })
  ),

  /** CLEAR STATE — project switch; preserves commandDefinitions **/
  on(AutomationActions.clearAutomationState, (state) => ({
    ...initialAutomationState,
    commandDefinitions: state.commandDefinitions,
  })),

  /** COMMON FAILURE **/
  on(AutomationActions.automationFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // service

  on(AutomationActions.loadService, (state) => ({
    ...state,
    loading: true,
  })),
  on(AutomationActions.loadServiceSuccess, (state, { apiServices }) => ({
    ...state,
    apiServices,
    loading: false,
    error: null,
  })),
  on(AutomationActions.addService, (state) => ({
    ...state,
    loading: true,
  })),
  on(AutomationActions.addServiceSuccess, (state, { service }) => ({
    ...state,
    apiServices: [...state.apiServices, service],
    loading: false,
    error: null,
  })),
  on(AutomationActions.deleteServices, (state) => ({
    ...state,
    loading: true,
  })),
  on(AutomationActions.deleteServicesSuccess, (state, { idList }) => {
    return {
      ...state,
      apiServices: [
        ...state.apiServices.filter((item) => !idList.includes(item.id)),
      ],
      loading: false,
      error: null,
    };
  }),
  on(AutomationActions.updateService, (state) => ({
    ...state,
    loading: true,
  })),
  on(AutomationActions.updateServiceSuccess, (state, { service }) => ({
    ...state,
    apiServices: [
      ...state.apiServices.map((srv) =>
        srv.id === service.id ? service : srv
      ),
    ],
    loading: false,
    error: null,
  })),

  // service operations
  on(AutomationActions.loadServiceOperation, (state) => ({
    ...state,
    loading: true,
  })),
  on(AutomationActions.loadServiceOperationSuccess, (state, { serviceOperations }) => ({
    ...state,
    serviceOperations,
    loading: false,
    error: null,
  })),
  on(AutomationActions.addServiceOperation, (state) => ({
    ...state,
    loading: true,
  })),
  on(AutomationActions.addServiceOperationSuccess, (state, { serviceOperations }) => ({
    ...state,
    serviceOperations: [...state.serviceOperations, serviceOperations],
    loading: false,
    error: null,
  })),
  on(AutomationActions.deleteServiceOperations, (state) => ({
    ...state,
    loading: true,
  })),
  on(AutomationActions.deleteServiceOperationsSuccess, (state, { idList }) => {
    return {
      ...state,
      serviceOperations: [
        ...state.serviceOperations.filter((item) => !idList.includes(item.id)),
      ],
      loading: false,
      error: null,
    };
  }),
  on(AutomationActions.updateServiceOperation, (state) => ({
    ...state,
    loading: true,
  })),
  on(AutomationActions.updateServiceOperationSuccess, (state, { serviceOperations }) => ({
    ...state,
    serviceOperations: [
      ...state.serviceOperations.map((srv) =>
        srv.id === serviceOperations.id ? serviceOperations : srv
      ),
    ],
    loading: false,
    error: null,
  })),


   // operation parameters
   on(AutomationActions.loadOperationParameters, (state) => ({
    ...state,
    loading: true,
  })),
  on(AutomationActions.loadOperationParametersSuccess, (state, { operationParameters }) => ({
    ...state,
    operationParameters,
    loading: false,
    error: null,
  })),
  on(AutomationActions.addOperationParameter, (state) => ({
    ...state,
    loading: true,
  })),
  on(AutomationActions.addOperationParameterSuccess, (state, { operationParameters }) => ({
    ...state,
    operationParameters: [...state.operationParameters, operationParameters],
    loading: false,
    error: null,
  })),
  on(AutomationActions.deleteOperationParameters, (state) => ({
    ...state,
    loading: true,
  })),
  on(AutomationActions.deleteOperationParametersSuccess, (state, { idList }) => {
    return {
      ...state,
      operationParameters: [
        ...state.operationParameters.filter((item) => !idList.includes(item.paramId)),
      ],
      loading: false,
      error: null,
    };
  }),
  on(AutomationActions.updateOperationParameter, (state) => ({
    ...state,
    loading: true,
  })),
  on(AutomationActions.updateOperationParametersSuccess, (state, { operationParameters }) => ({
    ...state,
    operationParameters: [
      ...state.operationParameters.map((srv) =>
        srv.paramId === operationParameters.paramId ? operationParameters : srv
      ),
    ],
    loading: false,
    error: null,
  })),


  //operation headers
  on(AutomationActions.loadOperationHeader, (state) => ({
    ...state,
    loading: true,
  })),
  on(AutomationActions.loadOperationHeaderSuccess, (state, { operationHeaders }) => ({
    ...state,
    operationHeaders,
    loading: false,
    error: null,
  })),
  on(AutomationActions.addOperationHeader, (state) => ({
    ...state,
    loading: true,
  })),
  on(AutomationActions.addOperationHeaderSuccess, (state, { operationHeaders }) => ({
    ...state,
    operationHeaders: [...state.operationHeaders, operationHeaders],
    loading: false,
    error: null,
  })),
  on(AutomationActions.deleteOperationHeader, (state) => ({
    ...state,
    loading: true,
  })),
  on(AutomationActions.deleteOperationHeaderSuccess, (state, { idList }) => {
    return {
      ...state,
      operationHeaders: [
        ...state.operationHeaders.filter((item) => !idList.includes(item.id)),
      ],
      loading: false,
      error: null,
    };
  }),
  on(AutomationActions.updateOperationHeader, (state) => ({
    ...state,
    loading: true,
  })),
  on(AutomationActions.updateOperationHeaderSuccess, (state, { operationHeaders }) => ({
    ...state,
    operationHeaders: [
      ...state.operationHeaders.map((srv) =>
        srv.id === operationHeaders.id ? operationHeaders : srv
      ),
    ],
    loading: false,
    error: null,
  })),

);
